import { Avatar, Box, Paper } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "./theme";

 export const ProfileContainer = styled(Box)({
  padding: "16px",  
  maxWidth: 600,
  margin: "0 auto",
  marginTop: " 0 px",  
  maxHeight: 350,
  
  ' & .heading':{
    color: 'black',
  },
  ' & .profile_info_paper':{
    padding: "16px", 
    height: "100%",
    borderRadius: "8px",
  },
  ' & .profile_info':{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "16px", 
    marginTop: "16px", 
  },
  ' & .section_header':{
    display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "12px", 
  textAlign: "center",
  },
  ' & .text_field_container':{
    marginTop: "12px", 
  },
  ' & .text_field_row':{
    marginBottom: "12px", 
  },
  ' & .save_button_container':{
    marginTop: "16px",  
    display: "flex",
    justifyContent: "flex-end",
  },
  ' & .profile_avatar':{
    width: 80,  
    height: 80,  
    marginBottom: "8px",  
    backgroundColor: Colors.primary,
  },
  ' & .profile_info':{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "16px", 
    marginTop: "16px", 
  }

 });
 